import { render } from "./HomeTips.vue?vue&type=template&id=6ba95c77&scoped=true"
import script from "./HomeTips.vue?vue&type=script&lang=js"
export * from "./HomeTips.vue?vue&type=script&lang=js"

import "./HomeTips.vue?vue&type=style&index=0&id=6ba95c77&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba95c77"]])

export default __exports__